// extracted by mini-css-extract-plugin
module.exports = {"title_heading":"headings_title_heading__3l3SE"};